export default __webpack_public_path__ + "static/media/sports07.65615978.png";